import { Icon } from '@blueprintjs/core';

import { IconCross } from './svg/IconCross';

import './Icon.style.sass';

export const RejectedYellow = () => (
  <div className="rejected-yellow">
    <Icon icon={<IconCross />} />
  </div>
);
